import './style.scss'

import { Select } from '~/components/controls'
import type { SelectValue } from '~/components/controls/Select'

import {
    PublicEmptyLegMarketSortType,
    PublicEmptyLegSortType,
} from '../../application/types'

type FilterButtonProps = {
    selectedValue: PublicEmptyLegMarketSortType,
    onChange: (value: PublicEmptyLegMarketSortType) => void,
}

export const PUBLIC_EMPTY_LEG_SORT_OPTIONS: Array<{
    label: string
    value: PublicEmptyLegMarketSortType
}> = [
    { label: 'Soonest', value: PublicEmptyLegSortType.SOONEST },
    { label: 'Latest', value: PublicEmptyLegSortType.LATEST },
    { label: 'Max payload', value: PublicEmptyLegSortType.MAX_PAYLOAD },
    { label: 'Min payload', value: PublicEmptyLegSortType.MIN_PAYLOAD },
]

export const FilterButton = ({ selectedValue, onChange }: FilterButtonProps) => {
    const handleChange = (value: SelectValue) => {
        const selectedOption = PUBLIC_EMPTY_LEG_SORT_OPTIONS.find((option) => option.value === value)
        if (selectedOption) onChange(selectedOption.value)
    }

    return (
        <div className="public-empty-legs__filter">
            <Select
                placeholder="Sort by"
                selectedValue={selectedValue}
                onChange={handleChange}
                modClass="public-empty-legs__select-sort"
                options={PUBLIC_EMPTY_LEG_SORT_OPTIONS}
                height={48}
                withBorder
                grey
                placeholderGrey={false}
                leftIcon={null}
                customOptionColors
                hideIndicatorSeparator
            />
        </div>
    )
}
